import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_appraiser_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_appraiser_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_appraiser_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-6 fv-row" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "col-lg-6 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_48 = {
  type: "submit",
  id: "kt_appraiser_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_49 = { class: "indicator-label" }
const _hoisted_50 = { class: "indicator-progress" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_52 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_53 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_appraiser_create_banks",
  "aria-expanded": "true",
  "aria-controls": "kt_appraiser_create_banks"
}
const _hoisted_54 = { class: "card-title m-0" }
const _hoisted_55 = { class: "fw-bolder m-0" }
const _hoisted_56 = {
  id: "kt_appraiser_create_banks",
  class: "collapse show"
}
const _hoisted_57 = { class: "card-body border-top p-9" }
const _hoisted_58 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_59 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_60 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_61 = { class: "fw-bold" }
const _hoisted_62 = { class: "fs-6 text-gray-600" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "indicator-label" }
const _hoisted_69 = { class: "indicator-progress" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_71 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_72 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_appraiser_create_prices",
  "aria-expanded": "true",
  "aria-controls": "kt_appraiser_create_prices"
}
const _hoisted_73 = { class: "card-title m-0" }
const _hoisted_74 = { class: "fw-bolder m-0" }
const _hoisted_75 = {
  id: "kt_appraiser_create_prices",
  class: "collapse show"
}
const _hoisted_76 = { class: "card-body border-top p-9" }
const _hoisted_77 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_78 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_79 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_80 = { class: "fw-bold" }
const _hoisted_81 = { class: "fs-6 text-gray-600" }
const _hoisted_82 = { class: "row mb-6" }
const _hoisted_83 = { class: "col fv-row" }
const _hoisted_84 = { class: "py-0" }
const _hoisted_85 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_86 = ["href", "aria-controls"]
const _hoisted_87 = { class: "me-3 rotate-90" }
const _hoisted_88 = { class: "svg-icon svg-icon-3" }
const _hoisted_89 = { class: "me-3" }
const _hoisted_90 = { class: "d-flex align-items-center" }
const _hoisted_91 = { class: "text-gray-800 fw-bolder" }
const _hoisted_92 = ["id"]
const _hoisted_93 = { class: "d-flex flex-wrap py-5" }
const _hoisted_94 = { class: "flex-equal me-5" }
const _hoisted_95 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_96 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_99 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_100 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_101 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_102 = { class: "flex-equal" }
const _hoisted_103 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_104 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_105 = ["value"]
const _hoisted_106 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_107 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_108 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_109 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_111 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { class: "indicator-label" }
const _hoisted_114 = { class: "indicator-progress" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'official-appraisal'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('appraiserDetails')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.appraiserSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('name')) + ": ", 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('appraiserName'),
                        disabled: _ctx.createdUser
                      }, null, 8, ["placeholder", "disabled"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "name" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('email')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "email",
                        name: "email",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('appraiserEmail'),
                        disabled: _ctx.createdUser
                      }, null, 8, ["placeholder", "disabled"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "email" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('phoneNumber')) + ": ", 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "phone",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('appraiserPhone'),
                        disabled: _ctx.createdUser
                      }, null, 8, ["placeholder", "disabled"]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ErrorMessage, { name: "phone" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('password')), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_Field, {
                            type: "password",
                            name: "password",
                            autocomplete: "new-password",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('newPassword'),
                            disabled: _ctx.createdUser
                          }, null, 8, ["placeholder", "disabled"]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_ErrorMessage, { name: "password" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_Field, {
                            type: "password",
                            name: "verifyPassword",
                            autocomplete: "new-password",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('verifyPassword'),
                            disabled: _ctx.createdUser
                          }, null, 8, ["placeholder", "disabled"]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_ErrorMessage, { name: "verifyPassword" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('contactPersonName')) + ": ", 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "personName",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('contactPersonName'),
                        disabled: _ctx.createdUser
                      }, null, 8, ["placeholder", "disabled"]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_ErrorMessage, { name: "personName" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate('contactPersonPhone')) + ": ", 1),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "personPhone",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('contactPersonPhone'),
                        disabled: _ctx.createdUser
                      }, null, 8, ["placeholder", "disabled"]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_ErrorMessage, { name: "personPhone" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('bankAccountDetails')) + ": ", 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "bankAccountDetails",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('bankAccountDetails'),
                        disabled: _ctx.createdUser
                      }, null, 8, ["placeholder", "disabled"]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_ErrorMessage, { name: "bankAccountDetails" })
                        ])
                      ])
                    ])
                  ])
                ]),
                (!_ctx.createdUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-white btn-active-light-primary me-2",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      _createElementVNode("button", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_50, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_51
                        ])
                      ], 512)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'official-appraisal'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("h3", _hoisted_55, _toDisplayString(_ctx.translate('appraiserBanks')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              (!_ctx.createdUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("span", _hoisted_59, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.translate('savingBanksNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("label", _hoisted_64, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.translate('banks')), 1)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_Multiselect, {
                    ref: "multiselect",
                    modelValue: _ctx.selectedBanks,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBanks) = $event)),
                    mode: "tags",
                    "close-on-select": false,
                    loading: _ctx.loading,
                    searchable: true,
                    "create-option": true,
                    options: _ctx.banks,
                    placeholder: _ctx.translate('selectBanks'),
                    valueProp: "id",
                    label: _ctx.multiSelectLabel,
                    noResultsText: _ctx.translate('noResultsFound'),
                    onOpen: _ctx.multiSelectOpened
                  }, null, 8, ["modelValue", "loading", "options", "placeholder", "label", "noResultsText", "onOpen"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_appraiser_create_banks_submit",
                ref: "submitBanksButton",
                class: "btn btn-primary",
                disabled: !_ctx.createdUser,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitBanks && _ctx.onSubmitBanks(...args)))
              }, [
                _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_69, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_70
                ])
              ], 8, _hoisted_67)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'official-appraisal'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("h3", _hoisted_74, _toDisplayString(_ctx.translate('appraiserPrices')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              (!_ctx.createdUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("span", _hoisted_78, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.translate('savingPricesNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appraiserPrices, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_property_type_${index}`,
                            "aria-controls": `kt_property_type_${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("span", _hoisted_88, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", _hoisted_91, _toDisplayString(item.name), 1)
                              ])
                            ])
                          ], 8, _hoisted_86)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_property_type_${index}`,
                          class: "fs-6 ps-10 collapse",
                          "data-bs-parent": "#kt_property_type",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("table", _hoisted_95, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_96, _toDisplayString(_ctx.translate('propertyType')), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("input", {
                                        disabled: "",
                                        type: "text",
                                        value: _ctx.translate('building'),
                                        class: "form-control form-control-sm form-control-solid text-muted"
                                      }, null, 8, _hoisted_97)
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_98, _toDisplayString(_ctx.translate('price')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('price'),
                                        "onUpdate:modelValue": ($event: any) => ((item.buildingPrices.price) = $event)
                                      }, null, 8, _hoisted_99), [
                                        [_vModelText, item.buildingPrices.price]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_100, _toDisplayString(_ctx.translate('percentage')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('percentage'),
                                        "onUpdate:modelValue": ($event: any) => ((item.buildingPrices.percentage) = $event)
                                      }, null, 8, _hoisted_101), [
                                        [_vModelText, item.buildingPrices.percentage]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("table", _hoisted_103, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.translate('propertyType')), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("input", {
                                        disabled: "",
                                        type: "text",
                                        value: _ctx.translate('land'),
                                        class: "form-control form-control-sm form-control-solid text-muted"
                                      }, null, 8, _hoisted_105)
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_106, _toDisplayString(_ctx.translate('price')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('price'),
                                        "onUpdate:modelValue": ($event: any) => ((item.landPrices.price) = $event)
                                      }, null, 8, _hoisted_107), [
                                        [_vModelText, item.landPrices.price]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_108, _toDisplayString(_ctx.translate('percentage')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('percentage'),
                                        "onUpdate:modelValue": ($event: any) => ((item.landPrices.percentage) = $event)
                                      }, null, 8, _hoisted_109), [
                                        [_vModelText, item.landPrices.percentage]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_92)
                      ]),
                      _hoisted_110
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_appraiser_create_prices_submit",
                ref: "submitPricesButton",
                class: "btn btn-primary",
                disabled: !_ctx.createdUser,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmitPrices && _ctx.onSubmitPrices(...args)))
              }, [
                _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_114, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_115
                ])
              ], 8, _hoisted_112)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}